import React from 'react';
import { motion } from 'framer-motion';
import { FiDownload, FiGithub, FiLinkedin, FiMail } from 'react-icons/fi';
import profileImage from '../images/perfil1.png';

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0 },
};

const Hero = ({ content, resumeHref }) => (
  <section id="home" className="hero-section">
    <div className="container hero-grid">
      <motion.div
        className="hero-copy"
        initial="hidden"
        animate="visible"
        variants={fadeUp}
        transition={{ duration: 0.6 }}
      >
        <p className="eyebrow">{content.eyebrow}</p>
        <h1>{content.title}</h1>
        <p className="hero-lead">{content.lead}</p>
        <p className="hero-support">{content.support}</p>

        <div className="hero-actions">
          <a className="button button-primary" href="#projects">
            {content.ctas.projects}
          </a>
          <a
            className="button button-secondary"
            href="https://linkedin.com/in/icarolanes"
            target="_blank"
            rel="noreferrer"
          >
            <FiLinkedin />
            {content.ctas.linkedin}
          </a>
          <a
            className="button button-secondary"
            href="https://github.com/icarolanes"
            target="_blank"
            rel="noreferrer"
          >
            <FiGithub />
            {content.ctas.github}
          </a>
          <a
            className="button button-secondary"
            href={resumeHref}
            target="_blank"
            rel="noreferrer"
          >
            <FiDownload />
            {content.ctas.resume}
          </a>
          <a className="button button-secondary" href="#contact">
            <FiMail />
            {content.ctas.contact}
          </a>
        </div>
      </motion.div>

      <motion.div
        className="hero-panel"
        initial={{ opacity: 0, x: 40 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.7, delay: 0.15 }}
      >
        <div className="profile-card">
          <img src={profileImage} alt={content.profile.name} className="profile-image" />
          <div className="profile-meta">
            <p className="profile-name">{content.profile.name}</p>
            <p className="profile-role">{content.profile.role}</p>
          </div>
        </div>

        <div className="signal-list">
          {content.signals.map((signal) => (
            <div key={signal.label} className="signal-item">
              <span className="signal-label">{signal.label}</span>
              <p>{signal.text}</p>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);

export default Hero;
